function state() {
  return {
    policies: [],
    policy: {},
    claims: [],
    claim: {},
    policiesMeta: {},
    claimsMeta: {},
    claimsHistoriesPolicy: {},
    claimsHistoriesClaim: {},
    partners: [],
    products: [],
    productCategories: [],
    uploadProgress: 0,
    templateUrl: {},
  };
}

export default state;
